<style lang="scss">
  @use "../../components/shared/tab-body.scss";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .notetaker-content {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(24px);

    .horizontal-line {
      width: 100%;
      height: 1px;
      @include colors.background-color("interfaceSwGrey_10");
    }

    .setting {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(16px);

      .setting-description {
        display: flex;
        flex-direction: column;

        .title {
          @include mixins.h3();
        }

        .description {
          @include mixins.body2();
          @include colors.color("textGrey");
        }
      }
    }
  }
</style>

<script>
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import Description from "../../components/shared/Description.svelte";
  import { integrationStore } from "../../stores";
  import AddNotes from "./components/AddNotes.svelte";
  import NoteContent from "./components/NoteContent.svelte";
  import NoteMapping from "./components/NoteMapping.svelte";
  import NotetakerPromo from "./NotetakerPromo.svelte";

  $: providerTitle = $integrationStore.getProviderTitle();

  $: enabled = $integrationStore.getValue("addNotetakerMeetings");

  $: generalNotetakerSettings = $integrationStore.getSettings("notetaker");

  $: addNotesSettings = generalNotetakerSettings.filter((setting) =>
    ["addNotetakerMeetings", "notetakerAddMethod"].includes(setting.key)
  );

  $: noteContentSetting = generalNotetakerSettings.find(
    (setting) => setting.key === "notetakerNoteContent"
  );
</script>

{#if $userStore.notetakerPlan}
  <div class="notetaker tab-body">
    <Description title="Notetaker Settings" />

    <div class="notetaker-content">
      <div class="setting">
        <div class="setting-description">
          <span class="title">Add notes to {providerTitle}</span>
          <span class="description"
            >Choose how you want Notetaker meetings sent to {providerTitle}</span
          >
        </div>
        <AddNotes {addNotesSettings} />
      </div>
      {#if enabled}
        <div class="horizontal-line"></div>
        <div class="setting">
          <div class="setting-description">
            <span class="title">Note content</span>
            <span class="description"
              >Select what you want to be contained in the note</span
            >
          </div>
          <NoteContent setting={noteContentSetting} />
        </div>
        <div class="horizontal-line"></div>
        <div class="setting">
          <div class="setting-description">
            <span class="title">Note mapping</span>
            <span class="description"
              >If notes are not mapped, they will be created but will not have a
              specific action type/category</span
            >
          </div>
          <NoteMapping />
        </div>
      {/if}
    </div>
  </div>
{:else}
  <NotetakerPromo />
{/if}
